import React, { useContext } from "react"
import { Accordion, Modal } from "react-bootstrap"
import { MdNotifications } from "react-icons/md"
import UsuarioContext from "../Context/Usuario"
import "./NotificacionesModal.css"

const NotificacionesModal = (props) => {
  const { usuario } = useContext(UsuarioContext)

  let content = null

  if (
    !usuario ||
    !usuario.notificaciones ||
    usuario.notificaciones.length === 0
  ) {
    content = <div>No hay notificaciones</div>
  } else {
    content = (
      <Accordion defaultActiveKey="0">
        {usuario.notificaciones.map((n, index) => {
          let objectString = null
          if (Array.isArray(n.objeto)) {
            objectString = (
              <ol>
                {n.objeto.map((o, idx) => (
                  <li key={index + "-" + idx}>{JSON.stringify(o)}</li>
                ))}
              </ol>
            )
          } else {
            objectString = JSON.stringify(n.objeto).replace(",", ", ")
          }
          return (
            <Accordion.Item eventKey={index} key={index}>
              <Accordion.Header>{n.mensaje}</Accordion.Header>
              <Accordion.Body>{objectString}</Accordion.Body>
            </Accordion.Item>
          )
        })}
      </Accordion>
    )
  }

  return (
    <div>
      <Modal
        show={props.show}
        onHide={() => {
          props.cerrar()
        }}
      >
        <Modal.Header closeButton>
          <h5>
            <MdNotifications />
            <div style={{ display: "inline-block", marginLeft: "1rem" }}>
              Notificaciones
            </div>
          </h5>
        </Modal.Header>
        <Modal.Body className="notificaciones-usuario-modal">
          {content}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default NotificacionesModal
